import Form from './form'
import React, { useMemo, useState } from 'react'
import { getInviteTemplateDetailPromise } from 'api/Util'

export default function CourseAdd (props) {
  const { id } = props.match.params
  const [data, setData] = useState({})

  useMemo(() => {
    if (!id) return

    getInviteTemplateDetailPromise(id).then(resp => {
      resp && setData(resp)
    })
  }, [id])

  return <Form mode='edit' data={data} setData={setData} {...props} />
}